export { default } from './CountdownReplacer';
